<template>
    <div class="page-user-list">
      <div class="vx-card p-6 minus-top">
        <div class="vx-row">
          <div class="vx-col title-classification">
            <span>{{$t('button.shadeRules')}}</span>
          </div>
        </div>
        <div class="container">
          <div class="vx-row">
            <div class="vx-col w-full mt-2">
              <vs-checkbox class="float-right" v-model="valueCheckbox"> <span>{{$t('warningManager.autoEvaluate')}}</span></vs-checkbox>
            </div>
          </div>
          <div class="vx-row tn">
            <div class="vx-col w-ful mt-2">
              <span class="text-description">{{$t('warningManager.textShadeRules')}}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2 drop-keyword">
            <div id="text"><span class="text-positive">{{$t('warningManager.positiveWords')}}</span></div>
            <vue-tags-input
            :class="{'' : !valueCheckbox, 'disable-input' : valueCheckbox}"
            v-model="tag"
            :tags="tagsPositive"
            @tags-changed ="newTags => tagsPositive = newTags"
            :placeholder ="$t('warningManager.importAndPress')"
            name="positive"
            :disabled="valueCheckbox==true"
            allow-edit-tags
            @input="checkKeypressDrop($event)"
            @before-adding-tag="checkTag"
            />
            </div>

          <div class="vx-col md:w-1/2 w-full mt-2 drop-keyword-negative">
            <div id="text"><span class="text-negative">{{$t('warningManager.negativeWords')}}</span></div>
            <vue-tags-input
            :class="{'' : !valueCheckbox, 'disable-input' : valueCheckbox}"
            v-model="tagnegative"
            :tags="tagsnegative"
            @tags-changed ="newTags => tagsnegative = newTags"
            :placeholder ="$t('warningManager.importAndPress')"
            name="negative"
            :disabled="valueCheckbox==true"
            allow-edit-tags
            @input="checkKeypressDropNegative($event)"
            @before-adding-tag="checkTag"
            />
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col w-full mt-5">
            <vs-button class="float-right" style="width:max-content" type="filled" @click="create" :disabled="disableUpdate">{{$t('button.update')}}</vs-button>
            </div>
          </div>
        </div>
    </div>
    </div>
</template>
<script>
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components:{
      VueTagsInput
  },
  data(){
    return{
      positive:null,
      negative:null,
      tag:'',
      tagsPositive:[],
      tagnegative:'',
      tagsnegative:[],
      responseData:null,
      valueCheckbox:false,
      disableUpdate:false
    }
  },
  computed:{

  },
  methods:{
    checkKeypressDropNegative: function(event){
      this.disableUpdate = false;
      if(event.includes(",")){
        document.getElementsByClassName('drop-keyword-negative')[0].getElementsByTagName('input')[0]
        .dispatchEvent(new KeyboardEvent('keydown',{'keyCode':'13'}))
      }
    },
    checkKeypressDrop: function(event){
      this.disableUpdate = false;
      if(event.includes(",")){
        document.getElementsByClassName('drop-keyword')[0].getElementsByTagName('input')[0]
        .dispatchEvent(new KeyboardEvent('keydown',{'keyCode':'13'}))
      }
    },
    checkTag: function(obj){
      const text = obj.tag.text.split(',')[0];
      obj.tag.text = text;
      if(this.responseData){
        const resultPositive =  this.responseData.positive;
        const resultNegative = this.responseData.negative;
        const inputPositive = this.tagsPositive.map(el => el.text).toString();
        const inputNegative = this.tagsnegative.map(el => el.text).toString();
        if(resultPositive.toLowerCase().includes(obj.tag.text.toLowerCase())
            || resultNegative.toLowerCase().includes(obj.tag.text.toLowerCase())
            || inputPositive.toLowerCase().includes(obj.tag.text.toLowerCase())
            || inputNegative.toLowerCase().includes(obj.tag.text.toLowerCase())
            ){
          this.disableUpdate = true;
          return this.$vs.notify({
            text: `Từ khoá ${obj.tag.text} đã được khai báo`,
            icon:'icon-alert',
            iconPack:'feather',
            color:'danger'
          })
        }else{
          this.disableUpdate = false;
        }
      }
        obj.addTag();
    },
    validateForm: function(){
        return !this.errors.any();
    },
    create: function(){
      let dataPositive = this.tagsPositive.map(el => el.text).toString();
      let dataNega = this.tagsnegative.map(el => el.text).toString();
      // if(dataPositive.length < 1 && dataNega.length < 1){
      //   return this.$vs.notify({
      //     text:'Trường sắc thái không được để trống',
      //     icon:'feather',
      //     iconPack:'icon-alert-cirlce',
      //     color:'danger'
      //   })
      // }
      const payload ={
        positive:dataPositive,
        negative:dataNega,
        autoRate: this.valueCheckbox ? 1 : 0
      };
      this.$vs.loading();
      this.$processor.post('/classification/create',payload).then((response) =>{
        this.responseData = response.data.classificationSetting;
        this.$vs.loading.close();
        this.$vs.notify({
          text:this.$t('warningManager.notifyUpdateSucces'),
          icon:'feather',
          iconPack:'icon-alert-cirlce',
          color:'primary'
        })
      }).catch((err) =>{})
    }
  },
   async created(){
     const payload ={};
     this.$processor.post('/classification/find-by-id',payload).then((response) =>{
       this.responseData = response.data.classificationSetting;
       if (this.responseData.positive.length > 0){
          let valueTags = this.responseData.positive.split(',')
          valueTags = valueTags.map(element => {
            return {
              text: element,
              tiClasses: ["ti-valid"]
            }
          });
          this.tagsPositive = valueTags;
       }

       if(this.responseData.negative.length > 0){
          let valueTagsNegative = this.responseData.negative.split(',');
          valueTagsNegative= valueTagsNegative.map(element =>{
          return {
            text: element,
            tiClasses: ["ti-valid"]
          }
          });
          this.tagsnegative = valueTagsNegative;
       }
       let valueCheckbox = this.responseData.autoRate;
       if(valueCheckbox == 0){
          this.valueCheckbox = false;
       }
       else{
          this.valueCheckbox = true;
       }
       this.tagsPositive = valueTags;
       this.tagsnegative = valueTagsNegative;

     }).catch((err) =>{})
  },

}
</script>
<style scoped>

.text-negative{
  color: red;
  font-size: 15px;
  font-weight: bold;
}
.text-positive{
  color: rgb(127, 168, 255);
  font-size: 15px;
  font-weight: bold;
}
#text{
  margin-bottom: 10px;
}
.tag-input{
  border-radius: 10px;
}
.ck{
  margin-left: 80%;
}
.text-description{
  font-size: 15px;
  /* font-weight: bold; */

}
.tn{
  margin-top: 10px;
  margin-bottom: 10px;
}
.title-classification{
  font-size: 2.2rem;
  font-weight: bold;
}
.disable-input {
  background-color: #ccc;
}
.minus-top{
  margin-top: -24px;
}
</style>
